<template>
  <div class="row">
    <div class="col-12 col-tl-8 clm__left">
      <div class="is--mobile clm__mobile-header">
        <h3 class="clm__title">{{data.title}}</h3>
        <a href="/pages/build-your-kit" class="btn btn--regular clm__btn">SHOP ALL KITS</a>
      </div>
      <div class="clm__selector-top">
        <span>Select</span>
        <svg class="clm__selector-icon">
          <use xlink:href="#icon-arrow-right"></use>
        </svg>
      </div>
      <div ref="topProductsSlider" class="swiper__carousel clm__top">
        <div class="swiper__row"> 
          <div v-for="(product,index) in topProducts" :key="index" class="swiper__col">
            <ImageField 
              :key="getImgUrl(product.title)"
              class="clm__product-img"
              :obj="{'url':getImgUrl(product.title),'alt':product.title,'width':526,'height':578}"
              :load="true" 
            />
          </div>
        </div>
        <div class="clm__nav clm__top-nav-prev">
          <svg class="clm__nav-prev-icon">
            <use xlink:href="#icon-prev"></use>
          </svg>
        </div>
        <div class="clm__nav clm__top-nav-next">
          <svg class="clm__nav-next-icon">
            <use xlink:href="#icon-next"></use>
          </svg>
        </div>
      </div>
      <div ref="bottomProductsSlider" class="swiper__carousel">
        <div class="swiper__row"> 
          <div v-for="(product,index) in bottomProducts" :key="index" class="swiper__col">
            <ImageField 
              :key="getImgUrl(product.title)"
              class="clm__product-img"
              :obj="{'url':getImgUrl(product.title),'alt':product.title,'width':526,'height':578}" 
              :load="true"
            />
          </div>
        </div>
        <div class="clm__nav clm__bottom-nav-prev">
          <svg class="clm__nav-prev-icon">
            <use xlink:href="#icon-prev"></use>
          </svg>
        </div>
        <div class="clm__nav clm__bottom-nav-next">
          <svg class="clm__nav-next-icon">
            <use xlink:href="#icon-next"></use>
          </svg>
        </div>
      </div>
      <div class="clm__selector-bottom">
        <span>Select</span>
        <svg class="clm__selector-icon">
          <use xlink:href="#icon-arrow-right"></use>
        </svg>
      </div>
    </div>
    <div class="col-12 col-tl-4">
      <div class="clm__sideWrapper">
        <div class="is--desktop">
          <h3 class="clm__title">{{data.title}}</h3>
          <a href="/pages/build-your-kit" class="btn btn--regular clm__btn">SHOP ALL KITS</a>
        </div>
        <div class="clm__sidebar__close" aria-label="close" @click="toggleProductInfo" tabindex="0">
          <svg class="clm__sidebar__close-icon">
            <use href="#close"></use>
          </svg>
        </div>
        <div ref="topProductsDetailsSlider" class="swiper__carousel clm__top-products">
          <div class="swiper__row"> 
            <div v-for="(product) in topProducts" :key="product.title" class="swiper__col clm__product-wrapper">
              <MixmatchProduct
                :product="product"
                :productForm="productsForm[product.title]"
              />
            </div>
          </div>
        </div>

        <div ref="bottomProductsDetailsSlider" class="swiper__carousel clm__bottom-products">
          <div class="swiper__row"> 
            <div v-for="(product) in bottomProducts" :key="product.title" class="swiper__col clm__product-wrapper">
              <MixmatchProduct
                :product="product"
                :productForm="productsForm[product.title]"
              />
            </div>
          </div>
        </div>
        <button class="btn btn--secondary btn--medium clm__getkit-btn" @click="atc">GET THE KIT</button>
        <span class="clm__free-shipping">Free shipping for orders over $99</span>
      </div>

      <div class="is--mobile">
        <button class="btn btn--white btn--medium clm__color-btn" @click="toggleProductInfo">Select Color & Size</button>
        <button class="btn btn--secondary btn--medium clm__getkit-btn" @click="atc">GET THE KIT</button>
        <span class="clm__free-shipping">Free shipping for orders over $99</span>
      </div>
    </div>
  </div>
</template>

<script setup>
  import { computed, toRefs, ref, onMounted, reactive, onBeforeMount,watch } from 'vue';
  import ImageField from '../global/image.vue';
  import MixmatchProduct from './mixmatch-product.vue'
  import Swiper from 'swiper';
  import SwiperCore, { Navigation,Controller,A11y } from 'swiper/core';
  SwiperCore.use([Navigation,Controller,A11y]);

  const props = defineProps({
    data: {
      type: Object,
      required: true,
    }
  })

  const {
    data
  } = toRefs(props)

  var topSlider = ref(null)
  var topProductsSlider = ref(null)
  var topDetailsSlider = ref(null)
  var topProductsDetailsSlider = ref(null)
  var bottomSlider = ref(null)
  var bottomProductsSlider = ref(null)
  var bottomDetailsSlider = ref(null)
  var bottomProductsDetailsSlider = ref(null)
  const productsForm = reactive({})
  var windowWidth = ref(window.innerWidth);
  
  onBeforeMount(() => {
    initialSetup();
  })

  onMounted(() => {
    initiateSwiper();
    
    window.addEventListener('resize', () => {
      windowWidth.value = window.innerWidth
    })
  })
 
  watch(windowWidth, (value) => {
    topSlider.value.destroy();
    topDetailsSlider.value.destroy();
    bottomSlider.value.destroy();
    bottomDetailsSlider.value.destroy();

    initiateSwiper();
  })

  const topProductsSwiper = computed(() => {
    return {
      slidesPerView: 1,
      centeredSlides: true,
      loop: true,
      loopedSlides: topProducts.value.length,
      wrapperClass: 'swiper__row',
      slideClass: 'swiper__col', 
      navigation: {
        nextEl: '.clm__top-nav-next',
        prevEl: '.clm__top-nav-prev',
      },
      breakpoints: {
        768:{
          slidesPerView: 3,
          spaceBetween: 48
        } 
      },
      a11y: {
        enabled: true
      }
    }
  })

const bottomProductsSwiper = computed(() => {
  return {
    slidesPerView: 1,
    centeredSlides: true,
    loop: true,
    loopedSlides: bottomProducts.value.length,
    wrapperClass: 'swiper__row',
    slideClass: 'swiper__col',
    navigation: {
      nextEl: '.clm__bottom-nav-next',
      prevEl: '.clm__bottom-nav-prev',
    },
    breakpoints: {
      768: {
        slidesPerView: 3,
        spaceBetween: 48
      }
    },
    a11y: {
      enabled: true
    }
  }
})

  const topProductsDetailsSwiper = computed(() => {
    return {
      slidesPerView: 'auto',
      slideToClickedSlide: true,
      loop: true,
      allowTouchMove: false,
      wrapperClass: 'swiper__row',
      slideClass: 'swiper__col', 
    }
  })

  const bottomProductsDetailsSwiper = computed(() => {
    return {
      slidesPerView: 'auto',
      slideToClickedSlide: true,
      loop: true,
      allowTouchMove: false,
      wrapperClass: 'swiper__row',
      slideClass: 'swiper__col', 
    }
  })

  const topProducts = computed(() => {
    return data.value.products.filter(product => product.tags.includes('mixmatch_top'))
  })

  const bottomProducts = computed(() => {
    return data.value.products.filter(product => product.tags.includes('mixmatch_bottom'))
  })

  const getImgUrl = (product) => {
    const {Color,Size,images} = productsForm[product]

    const imageData = window.getProductImages(images,Color);
    return imageData[0].src;
  }

  const initialSetup = () => {
    data.value.products.forEach(product => {
      var {title,options,variants,images} = product;
      productsForm[title] = {}
      productsForm[title].selectedVariant = variants[0];
      productsForm[title].images = images
      options.forEach((option,index) => {
        productsForm[title][option.name] = productsForm[title].selectedVariant[`option${index + 1}`];        
      })
    })
  }

  const initiateSwiper = () => {
    topSlider.value = new Swiper(topProductsSlider.value, topProductsSwiper.value)
    topDetailsSlider.value = new Swiper(topProductsDetailsSlider.value, topProductsDetailsSwiper.value);
    bottomSlider.value = new Swiper(bottomProductsSlider.value, bottomProductsSwiper.value);
    bottomDetailsSlider.value = new Swiper(bottomProductsDetailsSlider.value, bottomProductsDetailsSwiper.value);

    topSlider.value.controller.control = topDetailsSlider.value;
    topDetailsSlider.value.controller.control = topSlider.value;
    bottomSlider.value.controller.control = bottomDetailsSlider.value;
    bottomDetailsSlider.value.controller.control = bottomSlider.value;
  }

  const atc = async() => {
    var topActiveProduct = topDetailsSlider.value.el.querySelector('.swiper-slide-active').querySelector('.clm__product-title').innerHTML;
    var bottomActiveProduct = bottomDetailsSlider.value.el.querySelector('.swiper-slide-active').querySelector('.clm__product-title').innerHTML;
    var items = [];

    if(productsForm[topActiveProduct].selectedVariant.available){
      items.push({id: productsForm[topActiveProduct].selectedVariant.id,quantity:1})
    }

    if(productsForm[bottomActiveProduct].selectedVariant.available){
      items.push({id: productsForm[bottomActiveProduct].selectedVariant.id,quantity:1})
    }

    window.openCart({cartConfirmation:false})
    await window.Additem(items)
  }

  const toggleProductInfo = () => {
    document.querySelector('.clm__sideWrapper').classList.toggle('open--drawer')
  }
</script>